import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { pageTitle } from 'utils/events';

const Gtag = () => {
  const location = useLocation();

  useEffect(() => {
    gtag('event', 'page_view', {
      page_path: location.pathname,
      screen_name: location.pathname,
      page_title: pageTitle[location.pathname],
    });
  }, [location]);

  return null;
};

export default Gtag;
